import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { I18n, T } from '../../../utils/I18n/I18n';
import React, { useCallback, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { CITY_BY_POSTCODE, GET_USER_DATA } from "../../../screens/PersonalAreaScreen/queriesPersonalArea";
import { debounce } from "../../../utils/debounce";
import Button from '../../UI/Button/Button';
import FormInput from '../../UI/FormInput/FormInput';
import { CREATE_ADDRESS } from './queriesAddress';
import CountrySelect from "./CountrySelect/CountrySelect";
import "./PersonalAreaEditAddress.scss";
import { COUNTRIES } from './queriesAddress';
const isEmpty = (value) => value.trim() === '';

const PersonalAreaAddAddress = ({ setAddAddress }) => {
    const {
        register,
        handleSubmit,
        setError,
        reset,
        formState: { errors }
    } = useForm();
    const [createAddress, { error }] = useMutation(CREATE_ADDRESS, {
        refetchQueries: [{ query: GET_USER_DATA }],
    });

    const [companyIsValid, setCompanyIsValid] = useState(true);
    const companyInputRef = useRef();
    const oibInputRef = useRef();

    const [cityIsInvalid, setCityIsInvalid] = useState(false);
    const [fetchCity, { data }] = useLazyQuery(CITY_BY_POSTCODE);
    const delayedFetch = useCallback(postCode => debounce(() => fetchCity({ variables: {postCode} }), 500), []);

    const postcodeHandler = (e) => {
        e.persist();
        delayedFetch(Number.parseInt(e.target.value));
    };

    const onSubmit = async submitData => {

        const enteredCompany = companyInputRef.current.value;
        const enteredOib = oibInputRef.current.value.trim();

        const enteredCompanyIsValid = !isEmpty(enteredCompany);
        const enteredOibIsValid = !isEmpty(enteredOib);

        const formIsValid = (enteredCompanyIsValid && enteredOibIsValid) || (!enteredCompanyIsValid && !enteredOibIsValid);

        setCompanyIsValid(formIsValid);

        if(!formIsValid){
            return;
        }

        if (submitData.city === "default"){
            setCityIsInvalid(true);
            return;
        }

        // eslint-disable-next-line camelcase
        const { firstname, city, street, lastname, telephone, postcode, default_billing, default_shipping, country_code } = submitData;
        await createAddress({ variables: { firstname, lastname, street, city, telephone, postcode, company: enteredCompany, vat_id: enteredOib, country_code, default_billing, default_shipping } });
        setAddAddress(null);
        reset();
    };
    const { data: countries, loading } = useQuery(COUNTRIES);
    return (
        <form onSubmit={handleSubmit(onSubmit)} className="address-form">
            <span className="address-form__personal-area-title">
                <T id="address.addAddress" />
            </span>
            <fieldset className="address-form__contact">
                <p className="address-form__contact-title">
                    <T id="address.contactInfo" />
                </p>
                <FormInput register={register} type="text" text="Ime" name="firstname" errors={errors} required/>
                <FormInput register={register}  type="text" text="Prezime" name="lastname" errors={errors} required/>
                <FormInput register={register}  type="tel" text="Telefon" name="tel" errors={errors} required/>
            </fieldset>

            <fieldset className="address-form__company">
                <p className="address-form__company__title">
                    <T id="address.company" />
                </p>
                <label><T id="address.companyLabel"/></label>
                <input className="address-form__company__input" ref={companyInputRef} type="text" name="company"/>
                <label><T id="address.vatId"/></label>
                <input ref={oibInputRef} text="OIB" name="vat_id" />
                {!companyIsValid && <p className="address-form__company__error"><T id="address.companyError"/></p>}
                {error && <p className="address-form__company__error">{error.message.replace("GraphQL error: ", "")}</p>}
            </fieldset>

            <fieldset className="address-form__address">
                <p className="address-form__contact-title">
                    <T id="address.addressesList" />
                </p>
                <FormInput register={register} type="text" text={<T id="club.street" />} name="street" errors={errors} required/>
                <FormInput register={register} type="text" text={<T id="address.postcode" />}
                           name="postcode" errors={errors} onChange={postcodeHandler} required
                />
                <label className="input-field__label" htmlFor="city"><T id="address.city" /></label>
                <I18n>
                    {t => (
                        <>
                            <FormInput register={register} text={<T id="address.pickCity" />} name="city" errors={errors} required/>
                        </>
                    )}
                </I18n>
                {cityIsInvalid && <p className="address-form__company__error"><T id="address.choose"/></p>}
                <CountrySelect register={register} defaultCountry={'HR'}/>
                <div className="address-form__default_billing">
                    <input type="checkbox" name="default_billing" id="default_billing" />
                    <label htmlFor="default_billing">
                        <T id="address.useAsDefaultBilling" />
                    </label>
                </div>

                <div className="address-form__default_billing">
                    <input type="checkbox" name="default_shipping" id="default_shipping" />
                    <label htmlFor="default_shipping">
                        <T id="address.useAsDefaultShipping" />
                    </label>
                </div>

                <Button type="submit" trait="profile-hover" text={<T id="address.editAddress" />} />
                <div className="just-link" onClick={() => setAddAddress(null)}>
                    <T id="address.back" />
                </div>
            </fieldset>
        </form>

    );
};

export default PersonalAreaAddAddress;
